import React from "react";

export interface CardHeaderProps {
  /**
   * Content inside the card header, can be text or JSX elements.
   */
  children: React.ReactNode;
  /**
   * Allow handling click events for collapsing
   */
  onClick?: () => void;
  /**
   * Optional prop for dropdown icon alignment
   */
  hasDropdown?: boolean;
  /** Content to display on the right side (e.g., button, tag, collapse icon). */
  rightContent?: React.ReactNode;
  /** Optional header background color class (e.g., bg-semantic-bg-success, bg-semantic-bg-warning) */
  headerColor?: string;
}

/**
 * The header section of the card, which usually contains the title or any important action.
 */
export const CardHeader: React.FC<CardHeaderProps> = ({ children, onClick, hasDropdown = false, rightContent, headerColor,
}) => {
  const baseClasses = "px-4 py-3 flex items-center justify-between";
  const cursorClass = hasDropdown ? "cursor-pointer" : "";
  
  // If headerColor is provided, use it as top border color (4px thick stroke)
  // Map bg-* classes to border-t-* classes
  let topBorderClass = "";
  
  if (headerColor) {
    if (headerColor.includes("semantic-bg-success") || headerColor.includes("green")) {
      // Green border for neighbor cards
      topBorderClass = "border-t-4 border-green-500";
    } else if (headerColor.includes("semantic-bg-warning") || headerColor.includes("yellow")) {
      // Yellow border for cloud container
      topBorderClass = "border-t-4 border-yellow-500";
    }
  }
  
  // No bottom border - removed as requested
  const headerClasses = [baseClasses, topBorderClass, cursorClass].filter(Boolean).join(" ");
  
  return (
    <div
      className={headerClasses}
      onClick={onClick}
    >
      <div className="flex-1">{children}</div>
      {rightContent && <div className="flex items-center space-x-2">{rightContent}</div>}
    </div>
  );
};

export default CardHeader;
